import { checkUserStatusAndUpdateCensoredImagesRights } from "@modules/login-user/checkUserLoginStatus"
import { applyNotificationDots } from "./overall-user-notifications"
import "./user-menu"
import { updateMerkzettelStateInMenu } from "@modules/bookmarks/bookmarks-menu-item.ts"

const FiveMinutesInMilliseconds = 1000 * 60 * 5
if (SiteInfo.accessToken !== "" && userData.isLoggedIn) {
    applyNotificationDots(SiteInfo.accessToken)
    checkUserStatusAndUpdateCensoredImagesRights(FiveMinutesInMilliseconds) //every 5 minutes
}

updateMerkzettelStateInMenu()
